/**
 * WONDR Safety Razor — shared utilities (fade-up reveal, PBCart ATC)
 */
(function () {
  if (window.__wondrSrzSharedBooted) return;
  window.__wondrSrzSharedBooted = true;

  function revealIfInView(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh && rect.bottom > 0;
  }

  function enableAnimateScope(root) {
    (root || document).querySelectorAll('.wondr-srz').forEach(function (sec) {
      sec.classList.add('wondr-srz--animate');
    });
  }

  function initFadeUp(root) {
    var scope = root || document;
    enableAnimateScope(scope);

    var nodes = scope.querySelectorAll('.wondr-srz__fade-up:not(.is-visible)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
    );

    nodes.forEach(function (el) {
      if (revealIfInView(el)) {
        el.classList.add('is-visible');
        return;
      }
      obs.observe(el);
    });
  }

  async function waitForPBCart(tries, delay) {
    tries = tries || 80;
    delay = delay || 50;
    for (var i = 0; i < tries; i++) {
      if (window.PBCart && typeof window.PBCart.addLine === 'function') {
        return window.PBCart;
      }
      await new Promise(function (r) {
        setTimeout(r, delay);
      });
    }
    throw new Error('PBCart.addLine not available');
  }

  function openUnifiedDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  /**
   * @param {HTMLButtonElement} btn
   * @param {string} variantId
   * @param {number} qty
   * @param {{ addedLabel?: string, resetMs?: number }} opts
   */
  async function pbAtcClick(btn, variantId, qty, opts) {
    opts = opts || {};
    if (!variantId || btn.disabled) return;

    var resetMs = opts.resetMs || 2200;
    var addedLabel = opts.addedLabel || 'Toegevoegd!';
    var originalHtml = btn.innerHTML;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      var pb = await waitForPBCart();
      await pb.addLine(String(variantId), qty || 1);
      openUnifiedDrawer();
      btn.classList.add('wondr-srz__atc--added');
      if (opts.useHtmlFlash) {
        btn.innerHTML = addedLabel;
      } else {
        btn.textContent = addedLabel;
      }
      setTimeout(function () {
        btn.classList.remove('wondr-srz__atc--added');
        btn.innerHTML = originalHtml;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }, resetMs);
    } catch (err) {
      console.error('[WondrSrz] addLine failed', err);
      btn.innerHTML = originalHtml;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  function bindPbAtc(root) {
    (root || document).querySelectorAll('[data-wondr-srz-pb-atc]').forEach(function (btn) {
      if (btn.dataset.wondrSrzPbBound === 'true') return;
      btn.dataset.wondrSrzPbBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        var qty = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
        pbAtcClick(btn, variantId, qty, {
          addedLabel: btn.getAttribute('data-added-label') || 'Toegevoegd!',
          useHtmlFlash: btn.getAttribute('data-use-html-flash') === 'true',
          resetMs: parseInt(btn.getAttribute('data-reset-ms') || '2200', 10)
        });
      });
    });
  }

  function boot() {
    initFadeUp();
    bindPbAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initFadeUp(e.target);
    bindPbAtc(e.target);
  });

  window.WondrSrz = {
    initFadeUp: initFadeUp,
    waitForPBCart: waitForPBCart,
    pbAtcClick: pbAtcClick,
    bindPbAtc: bindPbAtc,
    openUnifiedDrawer: openUnifiedDrawer
  };
})();
